/* tslint:disable */
/* eslint-disable */
/**
 * pollination-server
 * Pollination Server OpenAPI Definition
 *
 * The version of the OpenAPI document: 1.6.2
 * Contact: info@pollination.cloud
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a Project
         * @param {string} owner
         * @param {ProjectCreate} projectCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject: (owner_1, projectCreate_1, ...args_1) => __awaiter(this, [owner_1, projectCreate_1, ...args_1], void 0, function* (owner, projectCreate, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('createProject', 'owner', owner);
            // verify required parameter 'projectCreate' is not null or undefined
            assertParamExists('createProject', 'projectCreate', projectCreate);
            const localVarPath = `/projects/{owner}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(projectCreate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Upsert a recipe filter to a project
         * @param {string} owner
         * @param {string} name
         * @param {ProjectRecipeFilter} projectRecipeFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectRecipeFilter: (owner_1, name_1, projectRecipeFilter_1, ...args_1) => __awaiter(this, [owner_1, name_1, projectRecipeFilter_1, ...args_1], void 0, function* (owner, name, projectRecipeFilter, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('createProjectRecipeFilter', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('createProjectRecipeFilter', 'name', name);
            // verify required parameter 'projectRecipeFilter' is not null or undefined
            assertParamExists('createProjectRecipeFilter', 'projectRecipeFilter', projectRecipeFilter);
            const localVarPath = `/projects/{owner}/{name}/recipes/filters`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(projectRecipeFilter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete a Project
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject: (owner_1, name_1, ...args_1) => __awaiter(this, [owner_1, name_1, ...args_1], void 0, function* (owner, name, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('deleteProject', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('deleteProject', 'name', name);
            const localVarPath = `/projects/{owner}/{name}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Remove a Project permissions
         * @param {string} owner
         * @param {string} name
         * @param {ProjectPolicySubject} projectPolicySubject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectOrgPermission: (owner_1, name_1, projectPolicySubject_1, ...args_1) => __awaiter(this, [owner_1, name_1, projectPolicySubject_1, ...args_1], void 0, function* (owner, name, projectPolicySubject, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('deleteProjectOrgPermission', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('deleteProjectOrgPermission', 'name', name);
            // verify required parameter 'projectPolicySubject' is not null or undefined
            assertParamExists('deleteProjectOrgPermission', 'projectPolicySubject', projectPolicySubject);
            const localVarPath = `/projects/{owner}/{name}/permissions`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(projectPolicySubject, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Remove a Project recipe filter
         * @param {string} owner
         * @param {string} name
         * @param {ProjectRecipeFilter} projectRecipeFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectRecipeFilter: (owner_1, name_1, projectRecipeFilter_1, ...args_1) => __awaiter(this, [owner_1, name_1, projectRecipeFilter_1, ...args_1], void 0, function* (owner, name, projectRecipeFilter, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('deleteProjectRecipeFilter', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('deleteProjectRecipeFilter', 'name', name);
            // verify required parameter 'projectRecipeFilter' is not null or undefined
            assertParamExists('deleteProjectRecipeFilter', 'projectRecipeFilter', projectRecipeFilter);
            const localVarPath = `/projects/{owner}/{name}/recipes/filters`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(projectRecipeFilter, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get a project
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject: (owner_1, name_1, ...args_1) => __awaiter(this, [owner_1, name_1, ...args_1], void 0, function* (owner, name, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getProject', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getProject', 'name', name);
            const localVarPath = `/projects/{owner}/{name}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get project access permissions
         * @param {string} owner
         * @param {string} name
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {Array<string>} [subjectType] The type of access policy subject
         * @param {Array<string>} [permission] An access policy permission string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectAccessPermissions: (owner_1, name_1, page_1, perPage_1, subjectType_1, permission_1, ...args_1) => __awaiter(this, [owner_1, name_1, page_1, perPage_1, subjectType_1, permission_1, ...args_1], void 0, function* (owner, name, page, perPage, subjectType, permission, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getProjectAccessPermissions', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getProjectAccessPermissions', 'name', name);
            const localVarPath = `/projects/{owner}/{name}/permissions`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            if (subjectType) {
                localVarQueryParameter['subject_type'] = subjectType;
            }
            if (permission) {
                localVarQueryParameter['permission'] = permission;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get project recipe filters
         * @param {string} owner
         * @param {string} name
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipeFilters: (owner_1, name_1, page_1, perPage_1, ...args_1) => __awaiter(this, [owner_1, name_1, page_1, perPage_1, ...args_1], void 0, function* (owner, name, page, perPage, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getProjectRecipeFilters', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getProjectRecipeFilters', 'name', name);
            const localVarPath = `/projects/{owner}/{name}/recipes/filters`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get project recipe repositories
         * @param {string} owner
         * @param {string} name
         * @param {string} [search] Search string to find recipes
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipeRepositories: (owner_1, name_1, search_1, page_1, perPage_1, ...args_1) => __awaiter(this, [owner_1, name_1, search_1, page_1, perPage_1, ...args_1], void 0, function* (owner, name, search, page, perPage, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getProjectRecipeRepositories', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getProjectRecipeRepositories', 'name', name);
            const localVarPath = `/projects/{owner}/{name}/recipes/repositories`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get project recipe versions
         * @param {string} owner
         * @param {string} name
         * @param {string} [search] Search string to find recipes
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipes: (owner_1, name_1, search_1, page_1, perPage_1, ...args_1) => __awaiter(this, [owner_1, name_1, search_1, page_1, perPage_1, ...args_1], void 0, function* (owner, name, search, page, perPage, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('getProjectRecipes', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('getProjectRecipes', 'name', name);
            const localVarPath = `/projects/{owner}/{name}/recipes`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List Projects
         * @param {string} [search] Search string to find projects
         * @param {Array<string>} [ids] The ID of a project to search for
         * @param {Array<string>} [names] The name of the project
         * @param {Array<string>} [owner] Owner of the project
         * @param {boolean} [_public] Boolean check for public/private projects
         * @param {Array<string>} [permissions] Filter by permission on given resource
         * @param {ProjectSortKey} [sortBy] Key to sort the list by
         * @param {SortEnum} [sortOrder] The order to sort the list
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects: (search_1, ids_1, names_1, owner_1, _public_1, permissions_1, sortBy_1, sortOrder_1, page_1, perPage_1, ...args_1) => __awaiter(this, [search_1, ids_1, names_1, owner_1, _public_1, permissions_1, sortBy_1, sortOrder_1, page_1, perPage_1, ...args_1], void 0, function* (search, ids, names, owner, _public, permissions, sortBy, sortOrder, page, perPage, options = {}) {
            const localVarPath = `/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }
            if (names) {
                localVarQueryParameter['names'] = names;
            }
            if (owner) {
                localVarQueryParameter['owner'] = owner;
            }
            if (_public !== undefined) {
                localVarQueryParameter['public'] = _public;
            }
            if (permissions) {
                localVarQueryParameter['permissions'] = permissions;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (perPage !== undefined) {
                localVarQueryParameter['per-page'] = perPage;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a Project
         * @param {string} owner
         * @param {string} name
         * @param {ProjectUpdate} projectUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: (owner_1, name_1, projectUpdate_1, ...args_1) => __awaiter(this, [owner_1, name_1, projectUpdate_1, ...args_1], void 0, function* (owner, name, projectUpdate, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('update', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('update', 'name', name);
            // verify required parameter 'projectUpdate' is not null or undefined
            assertParamExists('update', 'projectUpdate', projectUpdate);
            const localVarPath = `/projects/{owner}/{name}`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(projectUpdate, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Upsert a new permission to a project
         * @param {string} owner
         * @param {string} name
         * @param {ProjectAccessPolicy} projectAccessPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertProjectPermission: (owner_1, name_1, projectAccessPolicy_1, ...args_1) => __awaiter(this, [owner_1, name_1, projectAccessPolicy_1, ...args_1], void 0, function* (owner, name, projectAccessPolicy, options = {}) {
            // verify required parameter 'owner' is not null or undefined
            assertParamExists('upsertProjectPermission', 'owner', owner);
            // verify required parameter 'name' is not null or undefined
            assertParamExists('upsertProjectPermission', 'name', name);
            // verify required parameter 'projectAccessPolicy' is not null or undefined
            assertParamExists('upsertProjectPermission', 'projectAccessPolicy', projectAccessPolicy);
            const localVarPath = `/projects/{owner}/{name}/permissions`
                .replace(`{${"owner"}}`, encodeURIComponent(String(owner)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication JWTAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            // authentication APIKeyAuth required
            yield setApiKeyToObject(localVarHeaderParameter, "x-pollination-token", configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(projectAccessPolicy, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Create a Project
         * @param {string} owner
         * @param {ProjectCreate} projectCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(owner, projectCreate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProject(owner, projectCreate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.createProject']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Upsert a recipe filter to a project
         * @param {string} owner
         * @param {string} name
         * @param {ProjectRecipeFilter} projectRecipeFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectRecipeFilter(owner, name, projectRecipeFilter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createProjectRecipeFilter(owner, name, projectRecipeFilter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.createProjectRecipeFilter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Delete a Project
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(owner, name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProject(owner, name, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.deleteProject']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Remove a Project permissions
         * @param {string} owner
         * @param {string} name
         * @param {ProjectPolicySubject} projectPolicySubject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectOrgPermission(owner, name, projectPolicySubject, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProjectOrgPermission(owner, name, projectPolicySubject, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.deleteProjectOrgPermission']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Remove a Project recipe filter
         * @param {string} owner
         * @param {string} name
         * @param {ProjectRecipeFilter} projectRecipeFilter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectRecipeFilter(owner, name, projectRecipeFilter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteProjectRecipeFilter(owner, name, projectRecipeFilter, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.deleteProjectRecipeFilter']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get a project
         * @param {string} owner
         * @param {string} name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(owner, name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProject(owner, name, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.getProject']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get project access permissions
         * @param {string} owner
         * @param {string} name
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {Array<string>} [subjectType] The type of access policy subject
         * @param {Array<string>} [permission] An access policy permission string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectAccessPermissions(owner, name, page, perPage, subjectType, permission, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProjectAccessPermissions(owner, name, page, perPage, subjectType, permission, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.getProjectAccessPermissions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get project recipe filters
         * @param {string} owner
         * @param {string} name
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipeFilters(owner, name, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProjectRecipeFilters(owner, name, page, perPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.getProjectRecipeFilters']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get project recipe repositories
         * @param {string} owner
         * @param {string} name
         * @param {string} [search] Search string to find recipes
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipeRepositories(owner, name, search, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProjectRecipeRepositories(owner, name, search, page, perPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.getProjectRecipeRepositories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Get project recipe versions
         * @param {string} owner
         * @param {string} name
         * @param {string} [search] Search string to find recipes
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipes(owner, name, search, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProjectRecipes(owner, name, search, page, perPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.getProjectRecipes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary List Projects
         * @param {string} [search] Search string to find projects
         * @param {Array<string>} [ids] The ID of a project to search for
         * @param {Array<string>} [names] The name of the project
         * @param {Array<string>} [owner] Owner of the project
         * @param {boolean} [_public] Boolean check for public/private projects
         * @param {Array<string>} [permissions] Filter by permission on given resource
         * @param {ProjectSortKey} [sortBy] Key to sort the list by
         * @param {SortEnum} [sortOrder] The order to sort the list
         * @param {number} [page] Page number starting from 1
         * @param {number} [perPage] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects(search, ids, names, owner, _public, permissions, sortBy, sortOrder, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listProjects(search, ids, names, owner, _public, permissions, sortBy, sortOrder, page, perPage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.listProjects']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Update a Project
         * @param {string} owner
         * @param {string} name
         * @param {ProjectUpdate} projectUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(owner, name, projectUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.update(owner, name, projectUpdate, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.update']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @summary Upsert a new permission to a project
         * @param {string} owner
         * @param {string} name
         * @param {ProjectAccessPolicy} projectAccessPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertProjectPermission(owner, name, projectAccessPolicy, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upsertProjectPermission(owner, name, projectAccessPolicy, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['ProjectsApi.upsertProjectPermission']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProjectsApiFp(configuration);
    return {
        /**
         *
         * @summary Create a Project
         * @param {ProjectsApiCreateProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProject(requestParameters, options) {
            return localVarFp.createProject(requestParameters.owner, requestParameters.projectCreate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upsert a recipe filter to a project
         * @param {ProjectsApiCreateProjectRecipeFilterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProjectRecipeFilter(requestParameters, options) {
            return localVarFp.createProjectRecipeFilter(requestParameters.owner, requestParameters.name, requestParameters.projectRecipeFilter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete a Project
         * @param {ProjectsApiDeleteProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProject(requestParameters, options) {
            return localVarFp.deleteProject(requestParameters.owner, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a Project permissions
         * @param {ProjectsApiDeleteProjectOrgPermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectOrgPermission(requestParameters, options) {
            return localVarFp.deleteProjectOrgPermission(requestParameters.owner, requestParameters.name, requestParameters.projectPolicySubject, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a Project recipe filter
         * @param {ProjectsApiDeleteProjectRecipeFilterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProjectRecipeFilter(requestParameters, options) {
            return localVarFp.deleteProjectRecipeFilter(requestParameters.owner, requestParameters.name, requestParameters.projectRecipeFilter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get a project
         * @param {ProjectsApiGetProjectRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProject(requestParameters, options) {
            return localVarFp.getProject(requestParameters.owner, requestParameters.name, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get project access permissions
         * @param {ProjectsApiGetProjectAccessPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectAccessPermissions(requestParameters, options) {
            return localVarFp.getProjectAccessPermissions(requestParameters.owner, requestParameters.name, requestParameters.page, requestParameters.perPage, requestParameters.subjectType, requestParameters.permission, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get project recipe filters
         * @param {ProjectsApiGetProjectRecipeFiltersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipeFilters(requestParameters, options) {
            return localVarFp.getProjectRecipeFilters(requestParameters.owner, requestParameters.name, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get project recipe repositories
         * @param {ProjectsApiGetProjectRecipeRepositoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipeRepositories(requestParameters, options) {
            return localVarFp.getProjectRecipeRepositories(requestParameters.owner, requestParameters.name, requestParameters.search, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get project recipe versions
         * @param {ProjectsApiGetProjectRecipesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectRecipes(requestParameters, options) {
            return localVarFp.getProjectRecipes(requestParameters.owner, requestParameters.name, requestParameters.search, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Projects
         * @param {ProjectsApiListProjectsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProjects(requestParameters = {}, options) {
            return localVarFp.listProjects(requestParameters.search, requestParameters.ids, requestParameters.names, requestParameters.owner, requestParameters._public, requestParameters.permissions, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.page, requestParameters.perPage, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a Project
         * @param {ProjectsApiUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(requestParameters, options) {
            return localVarFp.update(requestParameters.owner, requestParameters.name, requestParameters.projectUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Upsert a new permission to a project
         * @param {ProjectsApiUpsertProjectPermissionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertProjectPermission(requestParameters, options) {
            return localVarFp.upsertProjectPermission(requestParameters.owner, requestParameters.name, requestParameters.projectAccessPolicy, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
    /**
     *
     * @summary Create a Project
     * @param {ProjectsApiCreateProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    createProject(requestParameters, options) {
        return ProjectsApiFp(this.configuration).createProject(requestParameters.owner, requestParameters.projectCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Upsert a recipe filter to a project
     * @param {ProjectsApiCreateProjectRecipeFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    createProjectRecipeFilter(requestParameters, options) {
        return ProjectsApiFp(this.configuration).createProjectRecipeFilter(requestParameters.owner, requestParameters.name, requestParameters.projectRecipeFilter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete a Project
     * @param {ProjectsApiDeleteProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    deleteProject(requestParameters, options) {
        return ProjectsApiFp(this.configuration).deleteProject(requestParameters.owner, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove a Project permissions
     * @param {ProjectsApiDeleteProjectOrgPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    deleteProjectOrgPermission(requestParameters, options) {
        return ProjectsApiFp(this.configuration).deleteProjectOrgPermission(requestParameters.owner, requestParameters.name, requestParameters.projectPolicySubject, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove a Project recipe filter
     * @param {ProjectsApiDeleteProjectRecipeFilterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    deleteProjectRecipeFilter(requestParameters, options) {
        return ProjectsApiFp(this.configuration).deleteProjectRecipeFilter(requestParameters.owner, requestParameters.name, requestParameters.projectRecipeFilter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get a project
     * @param {ProjectsApiGetProjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    getProject(requestParameters, options) {
        return ProjectsApiFp(this.configuration).getProject(requestParameters.owner, requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get project access permissions
     * @param {ProjectsApiGetProjectAccessPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    getProjectAccessPermissions(requestParameters, options) {
        return ProjectsApiFp(this.configuration).getProjectAccessPermissions(requestParameters.owner, requestParameters.name, requestParameters.page, requestParameters.perPage, requestParameters.subjectType, requestParameters.permission, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get project recipe filters
     * @param {ProjectsApiGetProjectRecipeFiltersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    getProjectRecipeFilters(requestParameters, options) {
        return ProjectsApiFp(this.configuration).getProjectRecipeFilters(requestParameters.owner, requestParameters.name, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get project recipe repositories
     * @param {ProjectsApiGetProjectRecipeRepositoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    getProjectRecipeRepositories(requestParameters, options) {
        return ProjectsApiFp(this.configuration).getProjectRecipeRepositories(requestParameters.owner, requestParameters.name, requestParameters.search, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get project recipe versions
     * @param {ProjectsApiGetProjectRecipesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    getProjectRecipes(requestParameters, options) {
        return ProjectsApiFp(this.configuration).getProjectRecipes(requestParameters.owner, requestParameters.name, requestParameters.search, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List Projects
     * @param {ProjectsApiListProjectsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    listProjects(requestParameters = {}, options) {
        return ProjectsApiFp(this.configuration).listProjects(requestParameters.search, requestParameters.ids, requestParameters.names, requestParameters.owner, requestParameters._public, requestParameters.permissions, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.page, requestParameters.perPage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a Project
     * @param {ProjectsApiUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    update(requestParameters, options) {
        return ProjectsApiFp(this.configuration).update(requestParameters.owner, requestParameters.name, requestParameters.projectUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Upsert a new permission to a project
     * @param {ProjectsApiUpsertProjectPermissionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectsApi
     */
    upsertProjectPermission(requestParameters, options) {
        return ProjectsApiFp(this.configuration).upsertProjectPermission(requestParameters.owner, requestParameters.name, requestParameters.projectAccessPolicy, options).then((request) => request(this.axios, this.basePath));
    }
}
